import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommissionsComponent } from './commissions/commissions.component';
import { WealthServicesComponent } from './wealth-services.component';

const routes: Routes = [
    {
        path: '',
        component: WealthServicesComponent,
        children: [
            {
                path: '',
                redirectTo: 'commissions',
                pathMatch: 'full',
            },
            {
                path: 'commissions',
                component: CommissionsComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WealthServicesRoutingModule {}
